import React, { Fragment, useContext, useEffect, useState } from 'react'
import { GoOrganization } from "react-icons/go";
import { SiAwsorganizations } from "react-icons/si";
import SuperAdminContext from '../../../hooks/SuperAdminContext';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Table } from 'react-bootstrap';
import axiosInstance from 'services/api/axiosInstance';


const EmployerDetailedView = () => {

    const navigate = useNavigate();
    const {
        selectedEmployer,
        jobs, employerTabSwitching,
        jobGlow, employerApplyFilterLoading,
        setemployerTabSwitching,
        jobFullDetails, setemployerJobsSortBy,
        employerTotalJobsDetails, employerJobsSortBy
    } = useContext(SuperAdminContext);


    const [jobDetails, setJobDetails] = useState([])
    const [showUsersList, setShowUsersList] = useState([])
    const [showUsers, setShowUsers] = useState(false)
    const [showUsersListGlow, setShowUsersListGlow] = useState(false)



    useEffect(() => {
        setJobDetails(employerTotalJobsDetails)
        handleJobsSortBy("All")
    }, [employerTotalJobsDetails])


    const handleJobsSortBy = (sortValue) => {
        if (sortValue === "All") {
            setJobDetails(jobFullDetails?.posted_job_details)
        } else {
            const filterSorting = jobFullDetails?.posted_job_details?.filter((value) => {
                return value?.job_status.toLowerCase() === sortValue.toLowerCase()
            })
            setJobDetails(filterSorting)
        }
        setemployerJobsSortBy(sortValue)
    }

    const handleGetUserListModal = async (user_id) => {
        setShowUsers(true)
        setShowUsersListGlow(true)

        try {
            const { data } = await axiosInstance.post("/get_sub_users", { employer_id: user_id })

            if (data?.error_code === 0) {
                if (data?.data?.length) {
                    setShowUsersList(data?.data)
                } else {
                    setShowUsersList([])
                }
                setShowUsersListGlow(false)
            } else {
                setShowUsersList([])
                setShowUsersListGlow(false)
            }
        } catch (Err) {
            console.log(Err?.message)
            setShowUsersList([])
            setShowUsersListGlow(false)
        }
    }

    return (
        <div className='col h-100 overflow-scroll'>
            {
                jobGlow || employerApplyFilterLoading || selectedEmployer ?
                    <>
                        <div className="card h-100 border-0">
                            <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                                <div className="container-fluid">
                                    <div className="row border-bottom border-secondary border-1 py-4">
                                        <div className="col-2 text-center">
                                            <img
                                                src={""}
                                                alt="..."
                                                width={100}
                                                height={100}
                                                className="pe-none placeholder rounded-circle"
                                            />
                                        </div>

                                        <div className="col-10">
                                            <div className="row">
                                                <div className="col-lg-6 col-xxl-8">
                                                    <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 border-end border-dark placeholder w-50 py-4 rounded-1 me-2"></h1>
                                                </div>
                                                <div className="col-12 gy-3 row">
                                                    <div className="col-6">
                                                        <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                                                    </div>

                                                    <div className="col-6">
                                                        <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                                                    </div>

                                                    <div className="col-6">
                                                        <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                                                    </div>

                                                    <div className="col-6">
                                                        <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 mt-3">
                                        <h1 className='employer-card-candidate-name placeholder rounded-2 col-4 py-4'></h1>
                                    </div>

                                    <div className="py-4 pt-2">
                                        <div>
                                            <h5 className="job-title-weight placeholder rounded col-4 py-3"></h5>
                                            <p className="job-description placeholder rounded-top skeleton-jobParagraph-medium col-12 mb-0"></p>
                                            <p className="job-description placeholder col-12 skeleton-jobParagraph-medium mb-0"></p>
                                            <p className="job-description placeholder rounded-bottom col-12 skeleton-jobParagraph-medium"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        {
                            jobs.length > 0 ?
                                <div className="card h-100 border-0">
                                    <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                                        <div className="container-fluid pb-5">
                                            <div className="row border-bottom border-secondary border-1 py-4">
                                                <div className="col-12 col-sm-3 col-xl-2 text-center">
                                                    <img
                                                        src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${jobFullDetails.profile_image}`}
                                                        alt=""
                                                        width={100}
                                                        height={100}
                                                        className="rounded-circle"
                                                    />
                                                </div>

                                                <div className="col-12 col-sm-7 col-xl-8 pt-4 pt-sm-0 ">
                                                    <div className="container p-0">
                                                        <div className="d-flex flex-wrap align-items-center h-100 col-12">
                                                            <div className={window.location.pathname === "/employer_dashboard/candidates/full_details"
                                                                ? "col-12 d-flex flex-wrap align-items-center text-center text-md-start"
                                                                : "col-12  d-flex flex-wrap align-items-center"
                                                            }>
                                                                <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 w-100 text-center text-sm-start">
                                                                    <span className="superAdmin-full-details-border pe-sm-3">
                                                                        {jobFullDetails.company_name}
                                                                    </span>

                                                                    <span className="employer-card-candidate-role mb-0 ps-3 d-none d-sm-inline-block">
                                                                        {jobFullDetails.employer_type}
                                                                    </span>
                                                                </h1>

                                                                <h1 className="employer-card-candidate-name mb-0 pe-3 w-100 d-block d-sm-none mt-3 text-center">
                                                                    <span className="employer-card-candidate-role mb-0 ">
                                                                        {jobFullDetails.employer_type}
                                                                    </span>
                                                                </h1>
                                                            </div>

                                                            {jobFullDetails.city !== "" ?
                                                                <div className="col-12 mt-3">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break mb-0"
                                                                        :
                                                                        "col-12 employer-card-candidate-role mb-0"}>
                                                                        <strong className='pe-0'>Location :</strong>
                                                                        <span className='ps-2'>{jobFullDetails.city},{jobFullDetails.country}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            {jobFullDetails.contact_number !== "" ?
                                                                <div className="col-12 mt-3">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break"
                                                                        :
                                                                        "col-12 employer-card-candidate-role"}>
                                                                        <strong className='pe-0'>Contact number :</strong>
                                                                        <span className='ps-2'>{jobFullDetails.contact_number}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            {jobFullDetails.email_id !== "" ?
                                                                <div className="col-12">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break"
                                                                        :
                                                                        "col-12 employer-card-candidate-role"}>
                                                                        <strong className='pe-0'>Email id :</strong>
                                                                        <span className='ps-2'>{jobFullDetails.email_id}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }

                                                            {jobFullDetails.website_url !== "" ?
                                                                <div className="col-12 ">
                                                                    <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                                                        "col-12 employer-card-candidate-role text-break"
                                                                        :
                                                                        "col-12 employer-card-candidate-role"}>
                                                                        <strong className='pe-0'>{`Website Url :`}</strong>
                                                                        <span className='ps-2'>{jobFullDetails.website_url}</span>
                                                                    </p>
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* {
                                                    ['premium', 'platinum']?.includes(jobFullDetails?.pricing_category?.toLowerCase()) ? */}
                                                        <div className="col">
                                                            <button type="button" className='btn btn-brand-color w-100' onClick={() => handleGetUserListModal(jobFullDetails?.user_id)}>
                                                                View users
                                                            </button>
                                                        </div>
                                                        {/* :
                                                        null
                                                } */}
                                            </div>


                                            <div className="py-4">
                                                <div className='row mt-1'>
                                                    <div className="col-12 col-md-8 col-xl-6 row">
                                                        <div className={`${employerTabSwitching === "about_company" ? "active" : ""} job-title-weight super-admin-employer-tab-switching col-6`} onClick={() => setemployerTabSwitching("about_company")}>
                                                            <p className='mb-0'>About Company</p>
                                                        </div>

                                                        <div className={`${employerTabSwitching === "job_details" ? "active" : ""} job-title-weight super-admin-employer-tab-switching col-6`} onClick={() => setemployerTabSwitching("job_details")}>
                                                            <p className='mb-0'>Job Details</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    employerTabSwitching === "about_company" ?
                                                        <Fragment>
                                                            <div className="d-flex my-4">
                                                                <div className="company-details-icon col-6">
                                                                    <GoOrganization className="me-2 text-success" />
                                                                    {jobFullDetails.employer_type}
                                                                </div>
                                                                <div className="company-details-icon col-6">
                                                                    <SiAwsorganizations className="me-2 text-warning" />
                                                                    {jobFullDetails.sector}
                                                                </div>
                                                            </div>
                                                            <p className="job-description">{jobFullDetails.company_description}</p>
                                                        </Fragment>
                                                        :

                                                        <div className="row mt-4">
                                                            <div className="col-12 row align-items-baseline">
                                                                <div className="col-6 col-lg-3">
                                                                    <p>
                                                                        <span className='text-secondary me-2'>Open Jobs:</span>
                                                                        {
                                                                            jobFullDetails?.posted_job_details[0]?.total_opened ?
                                                                                jobFullDetails?.posted_job_details[0]?.total_opened
                                                                                :
                                                                                0
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-6 col-lg-3">
                                                                    <p>
                                                                        <span className='text-secondary me-2'>Closed Jobs:</span>
                                                                        {
                                                                            jobFullDetails?.posted_job_details[0]?.total_closed ?
                                                                                jobFullDetails?.posted_job_details[0]?.total_closed
                                                                                :
                                                                                0
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-6 col-lg-3">
                                                                    <p>
                                                                        <span className='text-secondary me-2'>Paused Jobs:</span>
                                                                        {
                                                                            jobFullDetails?.posted_job_details[0]?.total_paused ?
                                                                                jobFullDetails?.posted_job_details[0]?.total_paused
                                                                                :
                                                                                0
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-12 col-sm-6 col-lg-3 text-end">
                                                                    <div className="col-12 col-sm-6 col-lg-12">
                                                                        <div className="dropdown">
                                                                            <button
                                                                                className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown btn-light"
                                                                                type="button"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <span className="fw-bold">Filter:</span>
                                                                                <span className="text-secondary ps-3">
                                                                                    {employerJobsSortBy === "Opened" ? "Open" : employerJobsSortBy}
                                                                                </span>
                                                                            </button>
                                                                            <ul className="dropdown-menu w-100 border-0 shadow">
                                                                                <li className="dropdown-item p-2 ps-3" onClick={() => handleJobsSortBy("All")}>
                                                                                    All
                                                                                </li>
                                                                                <li className="dropdown-item p-2 ps-3" onClick={() => handleJobsSortBy("Opened")}>
                                                                                    Open
                                                                                </li>
                                                                                <li className="dropdown-item p-2 ps-3" onClick={() => handleJobsSortBy("Paused")}>
                                                                                    Paused
                                                                                </li>
                                                                                <li className="dropdown-item p-2 ps-3" onClick={() => handleJobsSortBy("Closed")}>
                                                                                    Closed
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="card mt-4 px-3">
                                                                <div className="card-body px-0">
                                                                    <div className="table-responsive">
                                                                        <table className="table super-admin-employer">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Job Title & Posted Date</th>
                                                                                    <th>Viewed</th>
                                                                                    <th>Applied</th>
                                                                                    <th>Not Reviewed</th>
                                                                                    <th>Shortlisted</th>
                                                                                    <th>Rejected</th>
                                                                                    <th>Invited</th>
                                                                                    <th>Hired</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    jobDetails?.map((value, index) => {
                                                                                        return <tr key={index} className='superadmin-employer-table-tr'>
                                                                                            <td>
                                                                                                <p className='mb-1'>{value?.job_title}</p>
                                                                                                <p className='superadmin-employer-postedon'>Posted on : {value?.posted_on?.slice(5, 17)}</p>
                                                                                            </td>
                                                                                            <td className='text-center'>{value?.view_count}</td>
                                                                                            <td className='text-center'>{value?.applied_count}</td>
                                                                                            <td className='text-center'>{value?.not_reviewed_count}</td>
                                                                                            <td className='text-center'>{value?.shortlisted_count}</td>
                                                                                            <td className='text-center'>{value?.rejected_count}</td>
                                                                                            <td className='text-center'>{value?.contacted_count}</td>
                                                                                            <td className='text-center'>{value?.hired_count}</td>
                                                                                            <td>{value?.job_status && value?.job_status === "opened" ? "Open" : value?.job_status.charAt(0).toUpperCase() + value?.job_status.slice(1)}</td>
                                                                                            <td className='text-center'>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className='btn btn-brand-color'
                                                                                                    onClick={() => window.open(`/super_admin/jobs?job_id=${value?.job_id}`, '_blank')} >
                                                                                                    view
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="h-100 w-100 row align-items-center">
                                    <p className='text-center'>No Data Found</p>
                                </div>
                        }
                    </>
            }


            <Modal
                show={showUsers}
                onHide={() => setShowUsers(false)}
                size="xl"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton className='border-0'>
                    <Modal.Title className='modal_font_size_15'>
                        User List
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='py-3 userListHeight'>
                    {
                        showUsersListGlow ?
                            <div className="h-100 d-flex flex-wrap align-items-center justify-content-center">
                                <div className="col text-center">
                                    <div class="spinner-border text-warning" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>

                                    <p className='mt-2'>Getting Users List..</p>
                                </div>
                            </div>
                            :
                            showUsersList?.length ?
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Title</th>
                                            <th>Phone Number</th>
                                            <th>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            showUsersList?.map((v, i) => (
                                                <tr key={i} className='align-middle'>
                                                    <td>
                                                        {v?.first_name} {v?.last_name}
                                                        <p className='py-0 text-secondary mb-0'>
                                                            <span className='pe-1'>Added on :</span>
                                                            {v?.created_at?.slice(5, 16)}
                                                        </p>
                                                    </td>
                                                    <td>{v?.role}</td>
                                                    <td>{v?.title}</td>
                                                    <td>{v?.phone_number}</td>
                                                    <td>{v?.email_id}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                                :
                                <div className="h-100 d-flex flex-wrap align-items-center justify-content-center">
                                    <div className="col text-center">
                                        <p className='mt-2'>No Users Found</p>
                                    </div>
                                </div>
                    }
                </Modal.Body>

                <Modal.Footer className='border-0'>
                    <Button variant="secondary" onClick={() => setShowUsers(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default EmployerDetailedView